// export const API_BASE_URL = typeof process !== "undefined" ? process.env.VITE_API_BASE_URL_RESPONDER : import.meta.env.VITE_API_BASE_URL_RESPONDER;
// export const PUSHER_CLUSTER = typeof process !== "undefined" ? process.env.VITE_PUSHER_CLUSTER : import.meta.env.VITE_PUSHER_CLUSTER;
// export const PUSHER_KEY = typeof process !== "undefined" ? process.env.VITE_PUSHER_KEY : import.meta.env.VITE_PUSHER_KEY;

export const API_BASE_URL = process.env.VITE_API_BASE_URL_RESPONDER
export const PUSHER_CLUSTER = process.env.VITE_PUSHER_CLUSTER
export const PUSHER_KEY = process.env.VITE_PUSHER_KEY
export const API_GOOGLE_FONTS_KEY = process.env.VITE_GOOGLE_FONTS_API_KEY